import './SpeciesSpecificSeries.css'
import webinar_img9 from "./photos/farm-animals9.jpeg";
import webinar9_pdf from "./Resources/Webinar 9_FARM PPE.pdf";
import FirstWebinarResource from "./Resources/FirstWebinarResource";
import Webinars from "../BiosecurityWebSeries/Webinars";
const SpeciesSpecificSeries = () => {
    return (
        <div className= 'webinar-series' id ="species-specific-webinars">
            <h1 className= 'series-title' > Species-specific Webinars </h1>
            <div className= 'series-content' id = 'species-specific-content'>
                <Webinars img = {webinar_img9} date = "15 Mar"
                          title = "Basics of Biosecurity and Prevention of Disease in Backyard Poultry"
                          recording_link = "https://youtu.be/5zqRoy0csCc"
                          survey_link = "https://ucdavis.co1.qualtrics.com/jfe/form/SV_ewGXTMgK5hQCTl4"
                          presentation_slides = {webinar9_pdf}
                          resources = {<FirstWebinarResource/>}
                />
            </div>
        </div>
    )

}

export default SpeciesSpecificSeries;